import { render } from "./ReactProjects.vue?vue&type=template&id=27140eab&scoped=true"
import script from "./ReactProjects.vue?vue&type=script&lang=js"
export * from "./ReactProjects.vue?vue&type=script&lang=js"

import "./ReactProjects.vue?vue&type=style&index=0&id=27140eab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27140eab"]])

export default __exports__